import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {NotificationService} from "../../utils/notification.service";
import {BaseGeneral} from "../../utils/BaseGeneral";
import {BodyService} from "../../utils/body.service";
import {JsonApiService} from "../../../core/api/json-api.service";
import {AuthenticationService} from "../../../+auth/+login/authentication.service";

declare var $:any;

@Component({
  selector: 'sa-logout',
  template: `
      <div id="logout" (click)="showPopup()" class="btn-header transparent pull-right">
        <span> <a routerlink="/auth/login" title="Sign Out" data-action="userLogout"
                  data-logout-msg="Esta seguro de salir del Sistema?"><i
                class="fa fa-sign-out"></i></a> </span>
      </div>
  `,
  styles: []
})
export class LogoutComponent extends BaseGeneral {

  constructor(private router: Router,
              private authenticationService: AuthenticationService,
              protected notificationService: NotificationService,
              protected bodyService: BodyService,
              protected jsonApiService: JsonApiService) {
    super(bodyService, notificationService, jsonApiService);
  }

  showPopup(){
    this.notificationService.smartMessageBox({
      title : "<h1><i class='fa fa-sign-out txt-color-orangeDark'></i>&nbsp;Cerrar Sesión</h1> <span class='txt-color-orangeDark'><strong>" + $('#show-shortcut').text() + "</strong></span>",
      content : 'Está seguro de salir del Sistema?',
      buttons : '[No][Si]'

    }, (ButtonPressed) => {
      if (ButtonPressed == "Si") {
        this.logout()
      }
    });
  }

  logout(){
    this.authenticationService.logout();
    this.router.navigate(['/auth/login']);
    window.location.reload();

  }

  ngOnInit() {

  }



}



// WEBPACK FOOTER //
// ./src/app/shared/user/logout/logout.component.ts